import React from "react";
import FormGroupWrapper from "./FormGroupWrapper";
import { labelUtils, positionUtils } from "../Util";

const SelectBoxes = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let selectBoxesOptArray = fieldEle?.["data-customvalue"].split("#");
  let selectBoxesOptions = [];
  selectBoxesOptArray.forEach((opt) =>
    selectBoxesOptions.push({ key: opt, value: opt, label: opt })
  );

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        id={newElfromJSON}
        data-colsize={fieldEle?.["display-noofcolumns"]}
        style={{
          display: "grid",
          gridTemplateColumns: positionUtils.getGridColumsforBoxes(fieldEle),
          visibility: fieldEle?.["display-hidden"] === 1 ? "hidden" : "",
          width: labelUtils.getElementWidth(fieldEle),
        }}
      >
        {selectBoxesOptArray.map((itm, i) => {
          return (
            <div
              key={itm}
              className={"form-group pl-4"}
              id={arrEle.elementid + "-col-" + (i + 1)}
              data-colpos={i + 1}
            >
              <div className="pd-5">
                <label
                  htmlFor={newElfromJSON}
                  className={`form-check-label ${fieldEle?.["display-labelposition"]}`}
                >
                  <input
                    id={`${newElfromJSON}-${itm}`}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    value={itm}
                    className="form-check-input"
                    type="checkbox"
                    disabled={fieldEle?.["display-disabled"] === 1}
                    name={databaseKey ? databaseKey : displayLabelKey}
                  />
                  <span className="label-text">{itm}</span>
                </label>
              </div>
            </div>
          );
        })}
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};
export default SelectBoxes;
